import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation DeleteZone($deleteZoneId: ID!, $tenantId: ID!) {
    tenant(id: $tenantId) {
      deleteZone(id: $deleteZoneId) {
        id
      }
    }
  }
`
const TRANSFORMER = graphql.transformers.OUT.always(undefined)

export const executor = graphql.createExecutor<
  graphql.schema.DeleteZoneMutation,
  void,
  graphql.schema.DeleteZoneMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
